import wacToken from "./token/src/wac-token";

export { wacToken };
